export default "__VITE_ASSET__DS5n26WB__"